import type { ChatRoomParticipant } from "@/react/types/Chat/ChatRoomParticipant";

export const getAvatarStatus = (status: ChatRoomParticipant["status"]) => {
  switch (status) {
    case "online":
    case "idle":
      return status;
    default:
      return "none";
  }
};
